var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"makeorder-page-table-totalprice-width"},[_c('div',{staticClass:"makeorder-page-table-mobile-header"},[_vm._v("Total")]),_vm._v(" "+_vm._s(_vm.getDiff(_vm.product))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }